import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer>
            <div className="footer-bottom">
                <p>
                    Copyright &copy; 2022 Amond. Designed by
                    <a href="http://www.linkedin.com/in/ramiro-tanquias/" target="_blank"
                        rel="noopener noreferrer"><span> Leslie Mondragon</span>
                    </a>
                </p>
            </div>  
        </footer>
    )
}

export default Footer
